import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { copy } from "@/content";

export const Header = () => {
  const { lang, setLang } = useLanguage();
  const t = copy[lang].nav;

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 md:px-12">
        <a href="#top" data-testid="brand-logo" className="group flex items-baseline gap-1">
          <span className="font-tty text-xl font-bold text-white">
            Libertec
          </span>
          <span className="animate-caret font-tty text-xl font-bold text-acid">_</span>
        </a>

        <nav className="hidden items-center gap-8 md:flex" data-testid="main-nav">
          {[
            { label: t.manifesto, href: "#manifesto", id: "nav-manifesto" },
            { label: t.services, href: "#servicos", id: "nav-services" },
            { label: t.contact, href: "#contacto", id: "nav-contact" },
          ].map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={link.id}
              className="font-tty text-xs uppercase tracking-[0.2em] text-neutral-400 transition-colors duration-300 hover:text-acid"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <div className="flex border border-white/15 font-tty text-[11px] uppercase tracking-widest" data-testid="language-switcher">
            <button
              data-testid="lang-pt-button"
              onClick={() => setLang("pt")}
              className={`px-3 py-1.5 transition-colors duration-300 ${lang === "pt" ? "bg-acid text-black" : "text-neutral-400 hover:text-white"}`}
            >
              PT
            </button>
            <button
              data-testid="lang-en-button"
              onClick={() => setLang("en")}
              className={`px-3 py-1.5 transition-colors duration-300 ${lang === "en" ? "bg-acid text-black" : "text-neutral-400 hover:text-white"}`}
            >
              EN
            </button>
          </div>
          <a
            href="#contacto"
            data-testid="header-cta-button"
            className="hidden border border-acid px-4 py-1.5 font-tty text-[11px] uppercase tracking-widest text-acid transition-colors duration-300 hover:bg-acid hover:text-black md:block"
          >
            {t.cta}
          </a>
        </div>
      </div>
    </motion.header>
  );
};
